export const pxToRem = (pxValue: number): number => {
  // Retrieve the base font size in pixels from the CSS
  const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

  return pxValue / baseFontSize;
};

export const remToPx = (remValue: number): number => {
  // Retrieve the base font size in pixels from the CSS
  const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

  return remValue * baseFontSize;
};
